<template>
  <v-container class="service-down">
    <v-row no-gutters style="height: 100vh;">
      <v-col :align-self="'center'" justify-center class="text-center">
        <div class="text-vertical-center text-center">
          <v-img
            alt="logo DupliClick"
            width="300px"
            style="margin: 0 auto;"
            src="/logo/duplicarclick.svg"
          />
          <h1 class="font-weight-bold">
            Il servizio non &egrave; al momento disponibile
          </h1>
          <h3>Ci scusiamo per il disagio!</h3>
          <h4>Ti invitiamo a ricaricare la pagina tra qualche minuto.</h4>
          <h5 class="font-weight-bold">non puoi aspettare? contattaci</h5>
          <h3>Numero Verde 800 085 105</h3>
          <v-btn
            color="primary"
            style="text-decoration: none"
            class="font-weight-bold"
            :to="{ name: 'Home' }"
          >
            Ricarica la Homepage
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "ServiceDown"
};
</script>
<style lang="scss" scoped>
html,
body {
  width: 100% !important;
  height: 100% !important;
}
body {
  margin: 0 !important;
}
.service-down {
  display: table;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: $white;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  background-size: cover;
  -o-background-size: cover;
  padding: 0px !important;
  max-width: 100% !important;
  .text-vertical-center {
    text-align: center;
    vertical-align: middle;
    width: 100%;
  }
  .text-vertical-center h1 {
    margin: 0;
    padding: 0;
    color: $primary;
    margin: 0;
    padding: 18px 0;
    font: 900 35px;
  }
  .text-vertical-center h3 {
    margin: 0;
    padding: 5px 0;
    font: 800 22px;
  }
  .text-vertical-center h4 {
    margin: 0;
    padding: 0 0 30px 0;
    font: 400 20px;
  }
  .text-vertical-center h5 {
    margin: 0;
    padding: 0;
    color: $primary;
    margin: 0;
    padding: 30px 0 5px 0;
    font: 900 18px;
    text-transform: uppercase;
  }
}
</style>
